var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('Tab',{attrs:{"list":_vm.tabs},on:{"change":_vm.changeTab}}),_vm._v(" "),_c('CommonSwiper',{attrs:{"options":_vm.options,"show-pagination":false},on:{"ready":function($event){_vm.swiper = $event
      _vm.$emit('ready', $event)}}},[_c('div',{staticClass:"swiper-wrapper"},[_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }